"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTHLY_CARBON_PER_TREE_IN_KG = exports.YEARLY_CARBON_PER_TREE_IN_KG = exports.MONTHLY_CARBON_PER_TREE_IN_LBS = exports.YEARLY_CARBON_PER_TREE_IN_LBS = void 0;
exports.YEARLY_CARBON_PER_TREE_IN_LBS = 48;
exports.MONTHLY_CARBON_PER_TREE_IN_LBS = 4;
exports.YEARLY_CARBON_PER_TREE_IN_KG = 21.772432;
exports.MONTHLY_CARBON_PER_TREE_IN_KG = 1.8143693;
//# sourceMappingURL=Metrics.js.map